import {
  actions,
  getBreakdownOfPremuimsByPurchesSourceAsync,
  getCurrentPremiumCountAsync,
  getDailyBreakdownByPurchesSourceAsync,
  getFirstTimeSubscriptionCountAsync,
  getPromoCodeAliasBreakdownBySourceAsync,
  getUserRetentionForMultiplePointsAsync,
  getFirstTimeSubscriptionBreakdownByWeeksAsync,
  getDailyAquiredPremiumUsersAsync,
  getDailyLostPremiumUsersAsync,
  getDailyBreakdownByPurchesFilteredSourceAsync,
  getExpectedToBeLostPremiumsAsync,
  getDailyDowngradeSubscriptionAsync,
  getDailyUpgradeSubscriptionAsync,
  getDailyFirstTimeSubscriptionAsync,
  getDailyRefundsAsync,
  getdailyChurnedPremiumUsersAsync,
  getdailyReactivedPremiumUsersAsync,
  getDailyFaildToRenewPremiumUsersAsync,
  getDailyPromoCodeAliasAsync,
} from './slices';

export const PaymentAnalysisActions = {
  ...actions,
  getBreakdownOfPremuimsByPurchesSourceAsync,
  getCurrentPremiumCountAsync,
  getDailyBreakdownByPurchesSourceAsync,
  getFirstTimeSubscriptionCountAsync,
  getPromoCodeAliasBreakdownBySourceAsync,
  getUserRetentionForMultiplePointsAsync,
  getFirstTimeSubscriptionBreakdownByWeeksAsync,
  getDailyAquiredPremiumUsersAsync,
  getDailyLostPremiumUsersAsync,
  getDailyBreakdownByPurchesFilteredSourceAsync,
  getExpectedToBeLostPremiumsAsync,
  getDailyDowngradeSubscriptionAsync,
  getDailyUpgradeSubscriptionAsync,
  getDailyFirstTimeSubscriptionAsync,
  getDailyRefundsAsync,
  getdailyChurnedPremiumUsersAsync,
  getdailyReactivedPremiumUsersAsync,
  getDailyFaildToRenewPremiumUsersAsync,
  getDailyPromoCodeAliasAsync,
};
